<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="名称" prop="name">
              <a-input placeholder="请输入名称" v-model="model.name"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="描述" prop="remarks">
              <a-textarea :auto-size="{ minRows: 2, maxRows: 4}" placeholder="请输入流程描述" v-model="model.remarks" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              :labelCol="{xs: { span: 24 },sm: { span: 2 }}"
              :wrapperCol="{xs: { span: 24 },sm: { span: 22 }}"
              label="模板结构"
              prop="formStructure"
            >
              <div style="border-radius: 4px; border: 1px solid #ccc; overflow:hidden">
                <fm-making-form
                  :advance-fields="['editor', 'imgupload', 'file', 'subform', 'cascader']"
                  clearable
                  generate-code
                  generate-json
                  preview
                  ref="makingform"
                  style="height: 600px;"
                  upload
                >
                  <template slot="action" />
                </fm-making-form>
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>
  import Vue from 'vue'
  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  // 表单设计
  import {
    GenerateForm,
    MakingForm
  } from '@/components/VueFormMaking'
  import '@/components/VueFormMaking/styles/FormMaking.css'
  import ace from 'ace-builds'
  import 'ace-builds/webpack-resolver'
  Vue.use(ace)
  Vue.use(GenerateForm)
  Vue.use(MakingForm)

  export default {
    name: 'PTplInfoForm',
    components: {},
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        element: {
          "type": "select",
          "icon": "icon-select",
          "options": {
            "defaultValue": "",
            "multiple": false,
            "disabled": false,
            "clearable": false,
            "placeholder": "",
            "required": false,
            "showLabel": false,
            "width": "",
            "options": [{
              "value": "Option 1"
            }, {
              "value": "Option 2"
            }, {
              "value": "Option 3"
            }],
            "remote": false,
            "filterable": false,
            "remoteOptions": [],
            "props": {
              "value": "value",
              "label": "label"
            },
            "remoteFunc": "func_1653223949000_17671",
            "labelWidth": 100,
            "labelWidthDisabled": false,
            "labelWidthStatus": true,
            "displayVerifiy": {
              "type": "hide",
              "list": [{
                "model": "字段标识",
                "value": "字段值"
              }]
            }
          },
          "name": "下拉选择框",
          "key": "1653223949000_17671",
          "model": "select_1653223949000_17671",
          "rules": []
        },
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          name: [
            { required: true, message: '请输入名称!', trigger: 'blur' },
          ],
          formStructure: [
            { required: true, message: '请设计模版', trigger: 'blur' }
          ],
        },
        url: {
          add: "/workorder/pTplInfo/add",
          edit: "/workorder/pTplInfo/edit",
          queryById: "/workorder/pTplInfo/queryById"
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
        if (record.formStructure) {
          this.$nextTick(() => {
            this.$refs.makingform.setJSON(JSON.parse(record.formStructure))
          })
        }
      },
      handleSave (values) {
        if (values.list.length > 0) {
          this.model.formStructure = values
        } else {
          this.model.formStructure = ''
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.handleSave(this.$refs.makingform.getJSON())

        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>